import React from 'react';
import { Layout, Button } from 'antd';
import { ROUTES_MENU, ROUTES_MENU_LOGGED_IN } from '../../../../resources/routes-name';
import { navigateTo } from '../../../../utils/navigation';
import { useSelector } from 'react-redux';
const { Footer } = Layout;

const FooterLayout = () => {
  const userInfo = useSelector((state) => state.info);
  const menuList = userInfo?.employeeStatus ? ROUTES_MENU_LOGGED_IN : ROUTES_MENU;

  const handleMenuClick = (item) => {
    const pathname = item?.PATH || item?.path || '/';
    if (pathname) {
      navigateTo({ pathname });
    }
  };

  return (
    <Footer style={{ textAlign: 'center', padding: 0 }}>
      <div style={{ display: 'flex', justifyContent: 'center', gap: 16, padding: 8 }}>
        {menuList.map((item) => (
          <Button
            key={item.key}
            type="primary"
            shape="round"
            onClick={() => handleMenuClick(item)}
            style={{ minWidth: 120, backgroundColor: '#1890ff', color: '#fff' }}
          >
            {item.label}
          </Button>
        ))}
      </div>
    </Footer>
  );
};

export default FooterLayout;
